import { HistoryPeriodEnumKeys, TransactionStatusType } from '@libs/types';
import { CurrencyType, TransactionType } from 'src/constants';

export type TransactionFiltersType = {
  MINDATE?: string;
  MAXDATE?: string;
  ASSET: string[];
  TYPE: string[];
  STATUS: string[];
};

export type TransactionAppliedFilters = {
  assetCodes: CurrencyType[];
  types: TransactionType[];
  statuses: TransactionStatusType[];
  minDate?: string;
  maxDate?: string;
};

export enum TransactionMultiSelectFilterValues {
  ASSET = 'ASSET',
  STATUS = 'STATUS',
  TYPE = 'TYPE',
}

export const PERIOD_APPROPRIATE_TRANSLATIONS = {
  [HistoryPeriodEnumKeys.ONE_DAY]: 'time_24_hours',
  [HistoryPeriodEnumKeys.ONE_MONTH]: 'time_one_month',
  [HistoryPeriodEnumKeys.ONE_WEEK]: 'time_one_week',
  [HistoryPeriodEnumKeys.ONE_YEAR]: 'time_one_year',
  [HistoryPeriodEnumKeys.SIX_MONTHS]: 'time_six_months',
  [HistoryPeriodEnumKeys.THREE_MONTHS]: 'time_three_months',
  [HistoryPeriodEnumKeys.CURRENT_YEAR]: 'time_current_year',
};
